import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import FormAssembly from "../../../components/FormAssembly/FormAssembly";
import store from "../../../store";
import {Helmet} from "react-helmet";

const onlineBookingForm = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Manage" ? row.sections.map((section) => {
                        return section.title === "Forms & Applications" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Booking Account Request" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <h1 className="two-three-rows__title">Online Booking Form</h1>
      <div className="iframe-box-wrapper">
        <FormAssembly formReferenceName="ONLINE_BOOKING_FORM"/>
      </div>
    </div>
  );
};

export default onlineBookingForm;



// WEBPACK FOOTER //
// ./src/pages/manage/FormsAndApplications/OnlineBookingForm.js